
import { useNavigate } from "react-router-dom";
import { useListInventarioTodo } from "../../../hooks/cache";
import { CargandoMedio, ModalFormulario } from "../../components";
import { BuscadorXTermino } from "../../components/buscadores";
import { LayoutDesplegable } from "../../layouts";
import { FormCrearProdcutoStock, FormularioDescontarStock, TablaInventarios } from "../components";
import { iconos } from "../../../data";
import { useInventarioStore, useModalStore } from "../../../stores";



export const InventarioScreen = () => {


    const navigate = useNavigate();
    const { modalFormToggle, tipo } = useModalStore();
    const { activarInventario, setActivarInventario } = useInventarioStore();
    const { data, isLoading, chagePage, page, termino, chageTermino } = useListInventarioTodo();


    const handleCerrarModalInv = () => {
        setActivarInventario(null);
        modalFormToggle(false);
    }


    const menu = [ 
        { title: 'Crear Producto', action:() => modalFormToggle(true, 'crear-stock'), icon: iconos['plus'] },
        { title: 'Pagina Anterior', action:() => navigate(-1), icon: iconos['back'] },
    ];


    
    return (
        
        <LayoutDesplegable titulo="Inventario" subtitulo={`información inventario en stock`} menu={menu}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de ventas..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="buscar stock" playhol="nombre, medida..." />
                <TablaInventarios data={data || []} chagePage={chagePage} page={page} />
                </>
            }


            {(tipo === 'crear-stock') &&
            <ModalFormulario titulo={`${(activarInventario) ? 'Editar' : 'Crear' } Materia Prima`} valor={{}} onClose={ handleCerrarModalInv }>
                <FormCrearProdcutoStock handleCerrarModalInv={handleCerrarModalInv} />
            </ModalFormulario>
            }

            {(tipo === 'salida-stock') &&
            <ModalFormulario titulo={`Salidad de Stock`} valor={{}} onClose={ handleCerrarModalInv }>
                <FormularioDescontarStock handleCerrarModalInv={handleCerrarModalInv} />
            </ModalFormulario>
            }
        </LayoutDesplegable>
    )
}
